module.exports = __webpack_public_path__ + "static/media/fuel0.36362384.svg";